export default "__VITE_ASSET__de19085e__"